/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenBody
 */
export interface TokenBody {
    /**
     * 
     * @type {string}
     * @memberof TokenBody
     */
    token: string;
}

/**
 * Check if a given object implements the TokenBody interface.
 */
export function instanceOfTokenBody(value: object): value is TokenBody {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function TokenBodyFromJSON(json: any): TokenBody {
    return TokenBodyFromJSONTyped(json, false);
}

export function TokenBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenBody {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function TokenBodyToJSON(json: any): TokenBody {
    return TokenBodyToJSONTyped(json, false);
}

export function TokenBodyToJSONTyped(value?: TokenBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

